import ARIA, { ARIAElement } from "../utils/ARIA";
import TweenUtils from "../utils/TweenUtils";
import Scene from "./Scene";

export default class Button extends Phaser.GameObjects.Image {
	private _callback: () => any;
	private _callbackContext: any;

	private _pointerDown = false;
	private _pointerOver = false;
	private _pointerDownAnim: () => any;

	private _clickSoundKey = "buttonPress";
	private _buttonEnabled = true;

	private static _lastBtnId = 0;
	private _id: number;

	nameId: string;
	private inputEnabled = false;

	constructor(
		scene: Phaser.Scene,
		x: number,
		y: number,
		texture: string,
		frame?: string | number,
		callback?: () => any,
		callbackContext?: CallbackContext,
		bounce?: boolean
	) {
		super(scene, x, y, texture, frame);
		this._callback = callback;
		this._callbackContext = callbackContext;

		// input disabled for client in watch mode
		// if (!SessionData.Instance.watching) {
		this.enableInput();
		// }

		this._id = Button._lastBtnId;
		Button._lastBtnId++;
		if (bounce) {
			this.addPointerDownAnim(TweenUtils.ButtonBounce(scene, this));
		}
	}

	enableWatchModeInput(): void {
		this.enableInput();
	}

	private enableInput(): void {
		if (!this.inputEnabled) {
			this.inputEnabled = true;
			this.setInteractive();
			this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
			this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
			this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
			this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onPointerUp, this);
		}
	}

	setCallback(callback?: () => any, callbackContext?: CallbackContext): void {
		this._callback = callback;
		this._callbackContext = callbackContext;
	}

	destroy(): void {
		this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		super.destroy();
	}

	onPointerOver(): void {
		this._pointerOver = true;
	}

	onPointerOut(): void {
		this._pointerOver = false;
	}

	onPointerDown(ptr: Phaser.Input.Pointer): void {
		this.buttonDown(ptr);
	}

	buttonDown(_ptr: Phaser.Input.Pointer): void {
		this._pointerDown = true;
		if (this._pointerDownAnim != null && this._buttonEnabled) this._pointerDownAnim();
	}

	onPointerUp(): void {
		this.buttonUp();
	}

	buttonUp(): void {
		if (this._pointerDown && this._pointerOver && this._buttonEnabled) {
			this.playSound();
			if (this._callback != null) this._callback.bind(this._callbackContext)();
		}
		this._pointerDown = false;
	}

	playSound(): void {
		if (this.scene && this._clickSoundKey != undefined && this._clickSoundKey != null) {
			if (this.scene instanceof Scene) this.scene.soundManager.play(this._clickSoundKey);
			else this.scene.sound.play(this._clickSoundKey);
		}
	}

	addPointerDownAnim(anim: () => any): void {
		this._pointerDownAnim = anim;
	}

	removePointerDownAnim(): void {
		this._pointerDownAnim = null;
	}

	set clickSoundKey(value: string) {
		this._clickSoundKey = value;
	}

	set buttonEnabled(value: boolean) {
		this._buttonEnabled = value;
	}

	// ARIA Accessibility Functionality
	private aria?: ARIAElement;

	setARIA(text: string, layer?: string, focus = false): void {
		if (this.aria) {
			this.aria.setText(text);
			if (focus) this.aria.focus();
		} else this.aria = ARIA.addButton(this, text, layer, focus);
	}

	removeARIA(): void {
		if (this.aria) ARIA.removeElement(this.aria);
	}

	showARIA(): void {
		this.aria?.show();
	}

	hideARIA(): void {
		this.aria?.hide();
	}

	showARIALayer(layer?: string, hideRest = false): void {
		ARIA.showLayer(layer, hideRest);
	}

	hideLayer(layer?: string): void {
		ARIA.hideLayer(layer);
	}

	focusARIA(): void {
		this.aria?.focus();
	}

	blurARIA(): void {
		this.aria?.blur();
	}
}
